import * as types from 'model/actionTypes'
import { DictT, NoteT } from 'model/types'

const initialState: DictT<NoteT> = {}

export default function (state = initialState, action: { type: string; notes: DictT<NoteT> }) {
  switch (action.type) {
    case types.RECEIVE_NOTES_DICT:
      return {
        ...state,
        ...action.notes
      }
    case types.CLEAR:
    case types.LOGOUT:
      return initialState
    default:
      return state
  }
}
